import { DocumentNode, gql } from '@apollo/client';
import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { useListOfAuthors } from '@/components/Post/components/LikeCommentFooter/hooks/useListOfAuthors';
import { RespondButton } from '@/components/Post/components/RespondButton';
import { MessageCircleIcon } from '@/imports/ui/chakra/feather';

import { ReplyCount_CommentFragment } from './graphql-types/ReplyCount_CommentFragment';

export const ReplyCount: React.FC<{
  comment: ReplyCount_CommentFragment;
  onClick?: () => void;
}> & {
  commentFragment: DocumentNode;
} = ({ comment, onClick }) => {
  const commentAutorNames = comment.comments.map(
    (comment) => comment.author.displayName
  );
  const { readableListOfAuthors } = useListOfAuthors(commentAutorNames, 6);

  if (comment.comment) {
    return null;
  }

  return (
    <Tooltip
      label={readableListOfAuthors}
      isDisabled={!comment.comments?.length}
      placement="top"
      p="2"
    >
      <RespondButton
        leftIcon={<MessageCircleIcon />}
        onClick={onClick}
        color="gray.600"
        size="sm"
      >
        {comment.comments?.length || 0}
      </RespondButton>
    </Tooltip>
  );
};

ReplyCount.commentFragment = gql`
  fragment ReplyCount_CommentFragment on Comment {
    _id
    comment {
      _id
    }
    comments {
      _id
      author {
        _id
        displayName
      }
    }
  }
`;
